import apiClient from './client.js';
const base = (wsId) => `/workspaces/${wsId}/plugins`;
export const list = (wsId) => apiClient.get(base(wsId)).then(r => r.data);
export const install = (wsId, dto) => apiClient.post(base(wsId), dto).then(r => r.data);
export const update = (wsId, id, dto) => apiClient.patch(`${base(wsId)}/${id}`, dto).then(r => r.data);
export const uninstall = (wsId, id) => apiClient.delete(`${base(wsId)}/${id}`).then(r => r.data);
export const toggle = (wsId, id, isActive) => apiClient.patch(`${base(wsId)}/${id}/toggle`, { isActive }).then(r => r.data);
